<vc-page
  *ngIf="userData"
  pageType="home"
  [userData]="userData"
  [locale]="localeLang"
  [isMdUp]="isMdUp"
  [ctaListPost]="ctaListPost"
  [overwrightPage]="homePageFromResolver"
  (blockList$)="parseBlockList($event)"
  [updatedBlockList]="updatedBlockList"
  (onTrackClick)="onTrackClick($event)"
  (onTrackView)="onTrackView($event)"
  [showMysizesLabel]="showMysizesLabel"
>
  <vc-catalog
    *ngIf="configCatalogArray[0]"
    [config]="configCatalogArray[0]"
    [likedItem]="likedItem"
    pageType="home"
    (mySizesEmitter)="updateShowMysizesLabel($event)"
    [showMysizesLabel]="showMysizesLabel"
    catalog-product-one
  ></vc-catalog>
  <vc-catalog
    *ngIf="configCatalogArray[1]"
    [config]="configCatalogArray[1]"
    [likedItem]="likedItem"
    pageType="home"
    (mySizesEmitter)="updateShowMysizesLabel($event)"
    [showMysizesLabel]="showMysizesLabel"
    catalog-product-two
  ></vc-catalog>
  <vc-catalog
    *ngIf="configCatalogArray[2]"
    [config]="configCatalogArray[2]"
    [likedItem]="likedItem"
    pageType="home"
    (mySizesEmitter)="updateShowMysizesLabel($event)"
    [showMysizesLabel]="showMysizesLabel"
    catalog-product-three
  ></vc-catalog>
  <vc-catalog
    *ngIf="configCatalogArray[3]"
    [config]="configCatalogArray[3]"
    [likedItem]="likedItem"
    pageType="home"
    (mySizesEmitter)="updateShowMysizesLabel($event)"
    [showMysizesLabel]="showMysizesLabel"
    catalog-product-four
  ></vc-catalog>
  <vc-catalog
    *ngIf="configCatalogArray[4]"
    [config]="configCatalogArray[4]"
    [likedItem]="likedItem"
    pageType="home"
    (mySizesEmitter)="updateShowMysizesLabel($event)"
    [showMysizesLabel]="showMysizesLabel"
    catalog-product-five
  ></vc-catalog>
  <vc-catalog
    *ngIf="configCatalogArray[5]"
    [config]="configCatalogArray[5]"
    [likedItem]="likedItem"
    pageType="home"
    (mySizesEmitter)="updateShowMysizesLabel($event)"
    [showMysizesLabel]="showMysizesLabel"
    catalog-product-six
  ></vc-catalog>
  <vc-product-section
    *ngIf="recentlyViewedBlock?.displayBlock"
    [productList]="recentlyViewedProducts"
    [itemMax]="recentlyViewedBlock?.maxItems"
    [isSlider]="recentlyViewedBlock?.arrangement === 'slider'"
    [isCms]="true"
    recently-viewed-product
  ></vc-product-section>
</vc-page>
<span #ctaTranslation i18n-title="@@HOME.EDITO.MAIN_CTA" title="Show more" class="visuallyHidden"></span>

<ngx-json-ld [json]="schemas.search"></ngx-json-ld>
<ngx-json-ld [json]="schemas.organization"></ngx-json-ld>
